module.exports = __webpack_public_path__ + "static/pic23-ddfcd3d78ef1370af8825b67376a3c79.png";